<div class="file-uploader-container" [class.editable]="editableFields()">
  <div appUpload class="drop-zone" (onFileDropped)="handleDroppedFiles($event)">
    <div class="mb-3"><img width="98px" height="82px" src="./assets/images/file-upload-cloud.png" alt="file upload cloud icon" /></div>
    <h3 *appShowOnScreenSize="'desktop'" class="prompt">
      Drag here or <a class="browse-link" href="javascript:void(0)" (click)="fileInput.click()">browse</a> to upload
    </h3>
    <h3 *appShowOnScreenSize="'mobile'" class="prompt"><a class="browse-link" href="javascript:void(0)" (click)="fileInput.click()">Browse</a> to upload</h3>
    <input type="file" #fileInput multiple (change)="handleInputFiles($event)" class="d-none" />
    <p class="supported-files-msg">{{ supportedFilesLabel() }}</p>
  </div>
  <div>
    @if (hasError) {
      <div class="error-container mt-4">
        @if (fileSizeError()) {
          <p-message
            [severity]="fileSizeError()!.severity"
            [text]="fileSizeError()!.summary + ' ' + fileSizeError()!.detail" />
        }
        @if (fileTypeError()) {
          <p-message
            [severity]="fileTypeError()!.severity"
            [text]="fileTypeError()!.summary + ' ' + fileTypeError()!.detail" />
        }
      </div>
    }
    <app-loading-spinner [fullScreen]="false" [loading]="isLoading()" />
    @if (files() && files()!.length > 0) {
      <div class="d-none d-lg-flex justify-content-end">
        <a class="browse-link" href="javascript:void(0)" (click)="handleRemoveAll()">Remove All</a>
      </div>
    }
    <div class="files-list">
      @for (file of files(); track file.fileId) {
        <div class="file-row" [class.editable]="editableFields()">
          @if (canSetMainFile()) {
            <div>
              <input
                type="radio"
                [id]="file.fileId.toString()"
                name="mainFile"
                [value]="file.fileId"
                [formControl]="mainFileControl"
                pTooltip="Click to set as main photo"
                tooltipPosition="right" />
            </div>
          }
          <div class="file-thumbnail" [class.ml-5]="!canSetMainFile()">
            <img [src]="file.thumbnailUrl || createThumbnail(file?.file!)" width="50" />
          </div>

          @if (!editableFields() || showFileName()) {
            <p class="file-name" [ngStyle]="{ 'max-width': file?.category ? '16rem' : '30rem' }" [title]="file?.fileName">
              {{ truncateFilename(file?.fileName!, 40) }}
            </p>
          }
          @if (!file?.category) {
            <p class="file-size d-none d-lg-block">{{ returnFileSize(file.file?.size || file.savedFileSize) }}</p>
          }
          @if (editableFields()) {
            <div>
              <p>Description</p>
              <textarea
                class="description"
                id="file-name"
                placeholder="Description"
                type="text"
                pInputText
                [(ngModel)]="file.description"
                [disabled]="isDisabled()">
              </textarea>
            </div>
          }
          @if (file?.category) {
            <p class="file-category">{{ file?.category }}</p>
          }
          @if (!isDisabled()) {
            <div class="file-delete" (click)="deleteFile(file.fileId)">
              <i class="pi pi-times"></i>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
